import Autocompleter from './googleautocompleter';
import Autosuggester from './centersautosuggester';
import React from 'react';

let gmdv = require(`../../../ghc_config`);

const flfield = (props) => {
    let loadingElement = (<div style={{ height: `100%` }} />)
    return(
        <>
            <div style={{display: props.searchtype === `location` ? 'block' : 'none' }}>
                <Autocompleter
                    id="autocompleterComp"
                    title="autocompleterComp"
                    outline size="sm"
                    googleMapURL={gmdv.googleMapURL()}
                    loadingElement={loadingElement}
                    //  state values
                    placeholderAddress={props.placeholderAddress}
                    //  handlers
                    handleACupdate={props.handleACupdate}
                    handleCL={props.handleCL}
                />
            </div>
            <div style={{display: props.searchtype === `namecenter` ? 'block' : 'none' }}>
                <Autosuggester
                    label="Autosuggester"
                    id="Autosuggester"
                    outline size="sm"
                    className="form-control red-text-Genesis"
                    //  state values
                    locations={props.locations}
                    placeholderCName={props.placeholderCName}
                    //  handlers
                    handleCentersNames={props.handleCentersNames}
                    handleCN={props.handleCN}
                />
            </div>
        </>
    )
}

export default flfield